<template class="submitDig">
    <el-dialog title="" :visible.sync="submitDigVisible" center :before-close="handleClose">
        <p>{{formInfo.messageTitle}}</p>
        <!-- <p>我们将第一时间与您联系！</p> -->
        <p class="reply">{{formInfo.messageCode}}</p>
        <p class="reply">{{code}}</p>
        <p class="remarks">{{formInfo.messageRemark}}</p>
        <span slot="footer" class="dialog-footer">
            <el-button @click="submitDigVisible = false" type="info" plain>{{formInfo.btnClose}}</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data(){
        return{
          code: '',
          formInfo: {},
          submitDigVisible:false,
        }
    },
    methods:{
        open(code, data){
          this.formInfo = data;
          this.code = code;
          this.submitDigVisible = true;
        },
        handleClose(){
          this.code = ''
          this.submitDigVisible = false;
        }
    },
    created(){

    }
}
</script>
<style lang="less" scoped>
    p{
        text-align: center;
        font-size: 24px;
        line-height: 36px;
        margin: 0;
    }
    .reply{
        color: #d11a2d;
        padding-top: 5px;
    }
    .remarks{
        color: #808080;
        font-size: 20px;
        font-weight: 200;
    }
    button{
        padding: 12px 50px;
    }
    /deep/.el-dialog{
        width: 90%;
    }
    @media (min-width: 768px) and (max-width: 992px) {
        /deep/.el-dialog{
            width:60%;
        }
    }
    @media  (min-width: 992px) {
        /deep/.el-dialog{
            width:30%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/contactUs/components/submitDig.vue